import { createFileRoute } from '@tanstack/react-router';
import { HomeGuard } from '../components/pages/HomePage/HomeGuard';

export const Route = createFileRoute('/account/home')({
  component: HomeGuard,
});
